export const BOX_PREFIX = 'BOX:';

export function stripBoxPrefix(value = '') {
    const text = String(value === null || value === undefined ? '' : value);
    return text.replace(/^BOX:\s*/i, '').trim();
}

export function buildBoxComment(value = '') {
    const cleanValue = stripBoxPrefix(value);
    return (BOX_PREFIX + ' ' + cleanValue).replace(/\s+$/, '');
}
